import { render } from "./tournament-teams-players.vue?vue&type=template&id=b7db9e3c&ts=true"
import script from "./tournament-teams-players.vue?vue&type=script&lang=ts"
export * from "./tournament-teams-players.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Reports/tournament-teams-players.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7db9e3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7db9e3c', __exports__)) {
    api.reload('b7db9e3c', __exports__)
  }
  
  module.hot.accept("./tournament-teams-players.vue?vue&type=template&id=b7db9e3c&ts=true", () => {
    api.rerender('b7db9e3c', render)
  })

}


export default __exports__